export const core = [
  "JavaScript",
  "TypeScript",
  "React.js",
  "Next.js",
  "Node.js",
  "Nest.js",
  "PostgreSQL",
  "Docker",
];

export const languages = ["JavaScript", "TypeScript", "Python", "SQL", "HTML", "Linux"];

export const frontend = [
  "React.js",
  "Next.js",
  "Tailwind CSS",
  "CSS",
  "Redux",
  "Figma",
];

export const backend = [
  "Node.js",
  "Nest.js",
  "Express.js",
  "RESTful APIs",
  "Prisma ORM",
  "Keycloak",
];

export const databases = ["PostgreSQL", "MySQL", "MongoDB", "Redis", "Elasticsearch"];

export const cloudDevops = [
  "Docker",
  "Google Cloud Platform",
  "AWS",
  "Kubernetes",
  "Terraform",
  "GitHub Actions",
  "CI/CD",
];

export const testingTools = [
  "Jest",
  "Vitest",
  "Playwright",
  "Mocha",
  "Sentry",
  "Git",
  "GitHub",
  "Jira",
];
